import { useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

/**
 * App-wide React Query provider. Powers the REST data-fetching hooks that
 * replace the legacy Apollo GraphQL hooks during the backend migration.
 */
export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
    const [client] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnWindowFocus: false,
                        retry: 1,
                        staleTime: 30_000
                    }
                }
            })
    )

    return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
